import { useState } from "react";

const NewsCard = ({ news, onClick }) => {
  const [expanded, setExpanded] = useState(false);

  const handleSeeMore = () => {
    if (onClick) {
      onClick(news);
    }
  };

  // Get first letter of title for avatar
  const avatarLetter = news.title ? news.title.charAt(0).toUpperCase() : "N";

  return (
    <div className="w-full max-w-sm mx-auto bg-white cursor-pointer rounded-3xl shadow-xl overflow-hidden flex flex-col h-[450px] sm:h-[500px] md:h-[520px]" onClick={handleSeeMore}>
      {/* Header */}
      <div className="flex items-center justify-between p-3 sm:p-4">
        <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
            <span className="text-sm sm:text-base">{avatarLetter}</span>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm sm:text-lg font-bold text-gray-900 line-clamp-2 leading-tight">
              {news.title}
            </h3>
            
          </div>
        </div>
      </div>

      {/* Image */}
      <div className="relative overflow-hidden">
        <img
          src={news.imageUrl}
          alt={news.title}
          className="w-full h-36 sm:h-44 md:h-48 object-cover"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/news/news1.png";
          }}
        />
      </div>

      {/* Content */}
      <div className="p-3 sm:p-4 flex-1">
        <p className="text-gray-600 text-xs sm:text-sm line-clamp-3 sm:line-clamp-4 leading-relaxed">
          {news.description}
        </p>
      </div>

      {/* Actions */}
      <div className="px-3 sm:px-4 pb-3 sm:pb-4 flex items-center justify-between mt-auto">
        <button
          className="text-primary-600 hover:underline font-semibold"
          onClick={handleSeeMore}
        >
          See More
        </button>
        
      </div>

      {/* Expandable Content */}
      <div
        className={`px-3 sm:px-4 pb-3 sm:pb-4 overflow-hidden transition-all duration-300 ${
          expanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="border-t pt-3 sm:pt-4">
          <h4 className="font-bold text-gray-900 mb-2 text-sm sm:text-base">
            Full Description:
          </h4>
          <p className="text-gray-600 text-xs sm:text-sm mb-2 leading-relaxed">
            {news.description}
          </p>
          {news.content && (
            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
              {news.content}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsCard;

